<template>
<div id="container">
    <div class="product-status">
      <div class="explanatory-note">
          <i class="el-icon-warning-outline" style='width:12px;font-size:12px;padding-right:6px'></i>
          <span style='font-size:12px'>提供供应商报价单直接导入的功能，为了解析供应商报价单内容，需建立系统和供应商表头映射关系，请将同一含义的表头字段设置关联</span>
      </div>
      <div class="box-table">
        <el-table
          ref="multipleTable"
          :data="quoteConfigTable"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          border
        >
          <el-table-column prop="header" label="报价单表头"></el-table-column>
          <el-table-column prop="supplierHeader" label="供应商报价表头"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="skip" @click="onSet(scope.row)">
                设置关联
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <set-relevance @onGetList="getList" ref="setRelevanceRefs"></set-relevance>
    </div>
</div>
</template>
<script>
import setRelevance from './dialog/setRelevance'
import { supplierHeaderTemplateQueryAll } from '@/api/supplier/supplierManage'
export default {
  components: {
    'set-relevance': setRelevance
  },
  data () {
    return {
      quoteConfigTable: []
    }
  },
  created () {
    this.getList()
  },
  methods: {
    // 获取报价单表头和供应商报价表头所有关联
    getList () {
      supplierHeaderTemplateQueryAll().then(res => {
        if (res.data.code === 200) {
          this.quoteConfigTable = res.data.obj
        }
      })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 设置关联
    onSet (row) {
      this.$refs.setRelevanceRefs.onsetRelevance(row)
    }
  }
}
</script>
<style lang="scss" scoped>
.explanatory-note{
  background-color:#fff;
  margin-bottom:20px;
  font-size:14px;
  padding:17px 0 17px 30px;
  border-radius:4px;
  i{
    font-size: 18px;
    padding-right:20px;
    color: #C11A1A;
  }
}
</style>
